import { event } from "d3";
import { zoomSetup } from "./TechnicalAnalysis";

export function fundamentalsHover(_this, D3Chart) {
  const auxName = "fundamentals";

  function mouseover() {
    event.preventDefault();
    const xPixels = Math.max(
      Math.min(
        event.layerX - _this.chartElements.svgNode.margin.left,
        _this.chartElements.svgNode.width
      ),
      0
    );

    const xt = _this.chartElements.svgNode.x;
    const bandWidth = xt.bandwidth();
    const index = Math.floor(xPixels / bandWidth);
    const datName = xt.domain()[index];

    const selData = _this.allData.fundamentals.find(
      d => d.commodityName === datName
    );

    const yPixels = Math.max(
      Math.min(
        event.layerY - _this.chartElements.svgNode.margin.top,
        _this.chartElements.svgNode.height
      ),
      0
    );
    const xPix = _this.chartElements.svgNode.x(datName);

    // Showing elements
    for (let hoverElement of D3Chart.hoverElements) {
      hoverElement.show({
        yPixels,
        xPix,
        selData,
        xt,
        date: "commodityName",
        isLeftY: false
      });
    }
  }

  function mouseout() {
    // Hiding elements
    for (let hoverElement of D3Chart.hoverElements) {
      hoverElement.hide();
    }
  }

  zoomSetup(_this, "svgNode", "", auxName, "", mouseover, mouseout);
}
